import React, { useMemo, useEffect } from 'react';
import useTranslate from '../../Hooks/useTranslate';
import SchemaPaper from './SchemaPaper';
import { FullSizeColumn } from '../FlexBox';
import { useSetAtom, useAtomValue } from 'jotai'; // 1. Added useAtomValue
import { genericFormAtom } from '../../store/genericFormStore';

const SchemaWrapper = function SchemaWrapper({
  dynamicFilters,
  formatSchemaCallback,
  tabValue,
  filterParameters = [],
  onToggle,
}) {
  const resetAtom = useSetAtom(genericFormAtom);
  const payload = useAtomValue(genericFormAtom); // 2. Read the LIVE form state

  const formattedSections = useMemo(() => {
    return (dynamicFilters || []).map((section) => {
      const formattedItems = (section.items || []).map((filter) => {
        const currentSectionId = section.sectionId || filter.sectionId;
        const dynamicPath = `${currentSectionId}.${filter.waveFilterId}`;

        const uiSchema = filter?.uiSchemaConfiguration;

        const matchedParam = filterParameters.find(
          (param) =>
            param.waveFilterId === filter.waveFilterId &&
            (param.sectionId ? param.sectionId === currentSectionId : true)
        );

        const storedData = matchedParam?.filtersParameters;

        const finalSchema = formatSchemaCallback
          ? formatSchemaCallback(uiSchema, storedData, dynamicPath)
          : uiSchema
            ? JSON.parse(uiSchema)
            : [];

        return {
          ...filter,
          // Calculate the initial active state from the API
          initialActive:
            matchedParam?.active !== undefined
              ? matchedParam.active
              : filter.active,
          dynamicPath,
          finalSchema,
        };
      });

      return {
        ...section,
        items: formattedItems,
      };
    });
  }, [dynamicFilters, formatSchemaCallback, filterParameters]);

  useEffect(() => {
    return () => {
      resetAtom({});
    };
  }, [resetAtom]);

  return (
    <>
      {formattedSections.map(({ sectionId, items }) => (
        <FullSizeColumn
          key={sectionId}
          gap="24px"
          padding="8px"
          display={tabValue === sectionId ? 'flex!important' : 'none!important'}
        >
          {items.map((filter) => {
            // 3. Dig into the live Jotai payload to find the CURRENT active state
            let liveActiveState = undefined;
            if (payload && filter.dynamicPath) {
              const pathParts = filter.dynamicPath.split('.');
              let currentNode = payload;

              for (const part of pathParts) {
                currentNode = currentNode?.[part];
              }
              // Assume the form state saves the boolean under 'active'
              liveActiveState = currentNode?.active;
            }

            // 4. Use the live state if the user has clicked it, otherwise fallback to the API default
            const currentActive =
              liveActiveState !== undefined
                ? liveActiveState
                : filter.initialActive;

            return (
              <SchemaPaper
                key={filter?.dynamicPath}
                sectionId={sectionId}
                waveFilterId={filter?.waveFilterId}
                name={filter?.name}
                description={filter?.description}
                active={currentActive} // Passes the live state to the switch
                uiSchemaConfiguration={filter?.finalSchema ?? []}
                dynamicPath={filter?.dynamicPath}
                onToggle={onToggle}
              />
            );
          })}
        </FullSizeColumn>
      ))}
    </>
  );
};

export default SchemaWrapper;
